/**
 * Joinee documents and background verification.
 * Mounted under /hr, so these resolve to /hr/onboardingmanagement/verification*.
 */
export const verificationRoutes: any[] = [
  {
    // declared before ':id' so it is not swallowed as a case id
    path: 'onboardingmanagement/verification/documents',
    name: 'joineeDocuments',
    component: () => import('@/modules/hr/onboardingmanagement/verification/components/JoineeChecklist.vue'),
    meta: {
      title: 'routes.joineeDocuments',
      requiresAuth: true,
      breadcrumb: 'Joinee Documents',
    },
  },
  {
    path: 'onboardingmanagement/verification',
    name: 'bgvCases',
    component: () => import('@/modules/hr/onboardingmanagement/verification/components/BGVCaseList.vue'),
    meta: {
      title: 'routes.bgvCases',
      requiresAuth: true,
      breadcrumb: 'Background Verification',
    },
  },
  {
    path: 'onboardingmanagement/verification/:id',
    name: 'bgvCaseDetail',
    component: () => import('@/modules/hr/onboardingmanagement/verification/components/BGVCaseList.vue'),
    meta: {
      title: 'routes.bgvCaseDetail',
      requiresAuth: true,
      breadcrumb: 'Verification Case',
    },
  },
]

export default verificationRoutes
